export const BUSINESS_TRIAL_SUCCESS_DEMO_CENTER = {
  "en": "Want to see Dashlane in action? <a href=\"/demo\">Visit our Demo Center</a>",
  "fr": "",
  "de": "",
  "es": "",
  "pt-br": "Want to see Dashlane in action? <a href=\"/demo\">Visit our Demo Center</a>",
  "it": "Want to see Dashlane in action? <a href=\"/demo\">Visit our Demo Center</a>",
  "ja": "Want to see Dashlane in action? <a href=\"/demo\">Visit our Demo Center</a>",
  "ko": "Want to see Dashlane in action? <a href=\"/demo\">Visit our Demo Center</a>",
  "nl": "Want to see Dashlane in action? <a href=\"/demo\">Visit our Demo Center</a>",
  "pt-pt": "Want to see Dashlane in action? <a href=\"/demo\">Visit our Demo Center</a>",
  "sv": "Want to see Dashlane in action? <a href=\"/demo\">Visit our Demo Center</a>",
  "zh": "Want to see Dashlane in action? <a href=\"/demo\">Visit our Demo Center</a>"
}